import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { yourHome } from 'src/lib/flow/text';

import { FlowContext } from '../../../../lib/flow';

function isEnabled() {
  return true;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `Is ${yourHome(answers, channel)} part of a homeowner’s association (HOA)?`;
}

const hoaGuardPage: FlowPage = {
  slug: () => 'hoa-guard',
  isEnabled,
  title,
  autoAdvance: () => true,
  questions: ({ answers, inputContext: { channel } }: FlowContext): FlowQuestion[] => {
    return [
      {
        key: 'home.hoa',
        type: 'exclusives_radio_single_select',
        options: [
          {
            label: 'Yes',
            value: 'yes',
            followUps: [
              {
                key: 'home.hoa_type',
                type: 'multi_select',
                showNoneOfTheAbove: true,
                label: `Does ${yourHome(
                  answers,
                  channel,
                )} belong to any of these types of communities?`,
                options: [
                  {
                    label: 'Age restricted community',
                    value: 'age_restricted_community',
                  },
                  {
                    label: 'Gated community',
                    value: 'gated_community',
                    followUps: [
                      {
                        key: 'home.hoa_type.guarded_gated_community',
                        type: 'radio_single_select',
                        label: 'Is there a guard or call box at the entrance?',
                        helperText:
                          'A call box is a device that calls the homeowner to access the property.',
                        options: [
                          {
                            label: 'Yes',
                            value: 'has_guard',
                          },
                          {
                            label: 'No',
                            value: 'no_guard',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            label: 'No',
            value: 'no',
          },
        ],
      },
    ];
  },
};

export default hoaGuardPage;
